import { InputBase } from "@mui/material";

export function TextInput({
  variant,
  ...props
}: React.ComponentProps<typeof InputBase> & {
  variant?: "title" | "description";
}) {
  const fontSize = variant === "title" ? 20 : 14;
  const fontWeight = variant === "title" ? 500 : undefined;

  return (
    <InputBase
      {...props}
      sx={{
        width: "100%",
        fontSize: fontSize,
        fontWeight: fontWeight,
        px: 0,
        border: "none",
        outline: "none",
        "& .MuiInputBase-input": {
          padding: 0,
          resize: "none",
          whiteSpace: "pre-wrap",
        },
        "&:before, &:after": { display: "none" },
        "& .MuiInputBase-input:focus": {
          outline: "none",
          boxShadow: "none",
        },
        ...props.sx,
      }}
    />
  );
}
